export default __webpack_public_path__ + "static/hpay-help-bg-6f1b1d7ed1088f7482ef929a458f78ff.png";